import type { FC } from 'react'

import { Popup } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import { useNavigate } from 'react-router-dom'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'

export const AssetLinkPopup: FC<{
  isPopupOpen: boolean
  onClose: (open: boolean) => void
  link: string
}> = ({ isPopupOpen, onClose, link }) => {
  const translate = useTranslation()
  const navigate = useNavigate()
  return (
    <Popup
      variant="medium"
      ariaLabel={translate('Asset details')}
      isOpen={isPopupOpen}
      onClose={() => onClose(false)}
    >
      <div className="flex flex-col pt-6">
        <h3 className="center pb-6">
          <Translation id="Are you sure you want to leave this page?" />
          <br />
          <Translation id="Any unsaved progress will be lost" />
        </h3>
        <div className="flex flex-col justify-center sm:flex-row">
          <Button variant="secondary" onClick={() => onClose(false)}>
            <Translation id="Stay on Page" />
          </Button>

          <Button
            variant="primary"
            onClick={e => {
              navigate(link)
              e.stopPropagation()
            }}
          >
            <Translation id="Leave Page" />
          </Button>
        </div>
      </div>
    </Popup>
  )
}
